import { toast } from "sonner";
import { formatIDR, formatDate } from "@/lib/format";

const orderNo = (id) => `#${id.slice(-6).toUpperCase()}`;

export function remainingOf(t) {
  const net = (t.amount || 0);
  if (t.payment_status === "Lunas") return 0;
  const paid = (t.down_payment || 0) + (t.payments || []).reduce((s, p) => s + (p.amount || 0), 0);
  return Math.max(net - paid, 0);
}

export function printInvoice(t) {
  const row = (l, v) => `<tr><td style="padding:4px 0;color:#555">${l}</td><td style="padding:4px 0;text-align:right;font-weight:600">${v}</td></tr>`;
  const paid = (t.down_payment || 0) + (t.payments || []).reduce((s, p) => s + (p.amount || 0), 0);
  const rem = remainingOf(t);
  const block = (title, body) => body ? `<div style="margin-top:6px"><div style="font-size:10px;text-transform:uppercase;letter-spacing:1px;color:#888">${title}</div><div style="white-space:pre-line;font-size:12px;line-height:1.4;margin-top:1px">${body}</div></div>` : "";
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Invoice ${t._id.slice(-6)}</title>
    <style>body{font-family:Arial,sans-serif;color:#111;max-width:640px;margin:24px auto;padding:0 20px}
    h1{font-size:20px;margin:0;color:#0A1633}table{width:100%;border-collapse:collapse;font-size:14px}
    .muted{color:#777;font-size:12px}.hr{border-top:2px solid #C9A227;margin:14px 0}</style></head>
    <body>
    <div id="inv">
    <div style="display:flex;justify-content:space-between;align-items:flex-start">
      <div style="display:flex;align-items:center;gap:12px"><img src="https://customer-assets-jai6qajn.emergentagent.net/job_business-ledger-540/artifacts/e4f82042f591207e_WhatsApp%20Image%202026-10-07%20at%2015.59.58.jpeg" style="height:64px;width:64px;object-fit:cover;border-radius:12px;border:1px solid #C9A227" /><div><h1>LALA CORPORATION INDONESIA</h1><div class="muted">Invoice Order Bunga</div></div></div>
      <div style="text-align:right"><div class="muted">No. Order</div><div style="font-weight:700">${orderNo(t._id)}</div></div>
    </div>
    <div class="hr"></div>
    <table>
      ${row("Tanggal Order", formatDate(t.date))}
      ${row("Kategori", t.category || "-")}
      ${row("Pelanggan", (t.customer_name || "-") + (t.customer_phone ? " · " + t.customer_phone : ""))}
      ${row("Tempo", (t.customer_tempo && t.customer_tempo !== "0" ? t.customer_tempo + " hari" : "Cash") )}
      ${row("Status", t.payment_status)}
    </table>
    ${block("Ucapan", t.ucapan)}
    ${block("Dari", t.dari)}
    ${block("Alamat", t.alamat)}
    <div class="hr"></div>
    <table>
      ${row("Harga", formatIDR(t.amount))}
      ${row("Uang Muka", "- " + formatIDR(t.down_payment || 0))}
      ${row("Total Dibayar", formatIDR(paid))}
      ${row("<b>Sisa Tagihan</b>", "<b>" + formatIDR(rem) + "</b>")}
    </table>
    ${_signatureWithPay}
    <p class="muted" style="margin-top:24px">Terima kasih atas kepercayaan Anda. — ${formatDate(new Date().toISOString())}</p>
    </div>
    ${_waBar(t.customer_phone, orderNo(t._id))}
    <script>window.onload=function(){window.print()}</script>
    </body></html>`;
  const w = window.open("", "_blank", "width=720,height=800");
  if (w) { w.document.write(html); w.document.close(); }
}

export function printSupplierInvoice(b) {
  const row = (l, v) => `<tr><td style="padding:4px 0;color:#555">${l}</td><td style="padding:4px 0;text-align:right;font-weight:600">${v}</td></tr>`;
  const payments = b.payments || [];
  const histRows = payments.length
    ? payments.map((p) => `<tr><td style="padding:3px 0;color:#555">${formatDate(p.date)}${p.by_name ? " · " + p.by_name : ""}</td><td style="padding:3px 0;text-align:right">${(p.method || p.account || "-")}</td><td style="padding:3px 0;text-align:right;font-weight:600">${formatIDR(p.amount)}</td></tr>`).join("")
    : `<tr><td colspan="3" style="padding:6px 0;color:#999">Belum ada pembayaran.</td></tr>`;
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Invoice Supplier ${(b.invoice_no || "")}</title>
    <style>@page{size:A4;margin:16mm}body{font-family:Arial,sans-serif;color:#111;max-width:720px;margin:24px auto;padding:0 20px}
    h1{font-size:20px;margin:0;color:#0A1633}table{width:100%;border-collapse:collapse;font-size:14px}
    .muted{color:#777;font-size:12px}.hr{border-top:2px solid #C9A227;margin:14px 0}
    .tag{display:inline-block;padding:3px 10px;border-radius:999px;border:1px solid #C9A227;font-size:12px;font-weight:700}</style></head>
    <body>
    <div id="inv">
    <div style="display:flex;justify-content:space-between;align-items:flex-start">
      <div style="display:flex;align-items:center;gap:12px"><img src="https://customer-assets-jai6qajn.emergentagent.net/job_business-ledger-540/artifacts/e4f82042f591207e_WhatsApp%20Image%202026-10-07%20at%2015.59.58.jpeg" style="height:64px;width:64px;object-fit:cover;border-radius:12px;border:1px solid #C9A227" /><div><h1>LALA CORPORATION INDONESIA</h1><div class="muted">Invoice Tagihan Supplier</div></div></div>
      <div style="text-align:right"><div class="muted">No. Invoice</div><div style="font-weight:700">${b.invoice_no || "-"}</div><div class="tag" style="margin-top:6px">${b.payment_status || b.status || "-"}</div></div>
    </div>
    <div class="hr"></div>
    <table>
      ${row("Supplier", b.supplier_name || "-")}
      ${row("Keterangan", b.description || "-")}
      ${row("Dibuat / Admin", b.created_by_name || "-")}
      ${row("Tanggal Terbit", formatDate(b.issue_date))}
    </table>
    ${b.ucapan ? `<div style="margin-top:6px"><div style="font-size:10px;text-transform:uppercase;letter-spacing:1px;color:#888">Ucapan</div><div style="white-space:pre-line;font-size:12px;line-height:1.4;margin-top:1px">${b.ucapan}</div></div>` : ""}
    ${b.dari ? `<div style="margin-top:6px"><div style="font-size:10px;text-transform:uppercase;letter-spacing:1px;color:#888">Dari</div><div style="white-space:pre-line;font-size:12px;line-height:1.4;margin-top:1px">${b.dari}</div></div>` : ""}
    ${b.alamat ? `<div style="margin-top:6px"><div style="font-size:10px;text-transform:uppercase;letter-spacing:1px;color:#888">Alamat</div><div style="white-space:pre-line;font-size:12px;line-height:1.4;margin-top:1px">${b.alamat}</div></div>` : ""}
    <div class="hr"></div>
    <table>
      ${row("Total Tagihan", formatIDR(b.amount))}
      ${row("Total Dibayar", formatIDR(b.paid || 0))}
      ${row("<b>Sisa Tagihan</b>", "<b>" + formatIDR(b.remaining != null ? b.remaining : (b.amount - (b.paid || 0))) + "</b>")}
    </table>
    <div style="margin-top:16px"><div style="font-size:11px;text-transform:uppercase;letter-spacing:1px;color:#888;margin-bottom:4px">Riwayat Pembayaran</div>
    <table>${histRows}</table></div>
    ${_signature}
    <p class="muted" style="margin-top:24px">Dokumen ini dicetak dari sistem pembukuan Lala Corporation Indonesia. — ${formatDate(new Date().toISOString())}</p>
    </div>
    ${_waBar(b.supplier_phone, b.invoice_no || "invoice-supplier")}
    <script>window.onload=function(){window.print()}</script>
    </body></html>`;
  const w = window.open("", "_blank", "width=760,height=900");
  if (w) { w.document.write(html); w.document.close(); }
}

// ---------------------------------------------------------------------------
// Combined (gabungan) invoices — print-only, no new transactions are created
// ---------------------------------------------------------------------------
const _stamp = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}${p(d.getHours())}${p(d.getMinutes())}${p(d.getSeconds())}`;
};

const _esc = (v) => String(v == null ? "" : v)
  .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;").replace(/'/g, "&#39;");

const _waBar = (phone, invNo) => `
<div id="waBar" style="position:fixed;right:16px;bottom:16px;z-index:99;background:#0A1633;border:1px solid #C9A227;border-radius:12px;padding:8px;box-shadow:0 6px 20px rgba(0,0,0,.25);display:flex;gap:8px">
  <button id="waBtn" onclick='_sendWA(${JSON.stringify(phone || "")},${JSON.stringify(invNo)})' style="background:#C9A227;color:#0A1633;border:0;border-radius:8px;padding:8px 14px;font-weight:700;font-size:12px;cursor:pointer;font-family:Arial">Kirim ke WhatsApp (PDF)</button>
  <button onclick="window.print()" style="background:transparent;color:#fff;border:1px solid #C9A227;border-radius:8px;padding:8px 12px;font-size:12px;cursor:pointer;font-family:Arial">Cetak</button>
</div>
<style>@media print{#waBar{display:none !important}}</style>
<script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js"></script>
<script>
function _normPhone(p){p=(p||"").replace(/[^0-9]/g,"");if(p.indexOf("0")===0){p="62"+p.slice(1)}else if(p.indexOf("8")===0){p="62"+p}return p}
function _sendWA(phone,invNo){
  var btn=document.getElementById("waBtn");btn.disabled=true;btn.textContent="Membuat PDF...";
  var el=document.getElementById("inv")||document.body;
  var fname=String(invNo||"invoice").replace(/#/g,"");
  html2pdf().set({margin:10,filename:fname+".pdf",image:{type:"jpeg",quality:0.95},html2canvas:{scale:2,useCORS:true},jsPDF:{unit:"mm",format:"a4",orientation:"portrait"}}).from(el).save().then(function(){
    var msg=encodeURIComponent("Berikut invoice "+invNo+" dari Lala Corporation Indonesia. File PDF invoice terlampir.");
    var p=_normPhone(phone);
    window.open("https://wa.me/"+(p?p+"?text=":"")+(p?msg:"?text="+msg),"_blank");
    btn.disabled=false;btn.textContent="Kirim ke WhatsApp (PDF)";
  }).catch(function(){btn.disabled=false;btn.textContent="Kirim ke WhatsApp (PDF)";alert("Gagal membuat PDF. Coba lagi.");});
}
</script>`;

const _combCss = `
  @page{size:A4;margin:14mm;@bottom-center{content:"Halaman " counter(page) " dari " counter(pages);font-size:10px;color:#888}}
  body{font-family:Arial,sans-serif;color:#111;max-width:760px;margin:20px auto;padding:0 16px;font-size:13px}
  h1{font-size:19px;margin:0;color:#0A1633}table{border-collapse:collapse}
  .muted{color:#777;font-size:11px}.hr{border-top:2px solid #C9A227;margin:12px 0}
  .meta{width:100%;font-size:13px}.meta td{padding:3px 0;vertical-align:top}
  .items{width:100%;font-size:12px;margin-top:8px}
  .items th{background:#0A1633;color:#fff;padding:6px 8px;text-align:left;font-size:11px;text-transform:uppercase;letter-spacing:.4px;border-bottom:2px solid #C9A227}
  .items td{padding:4px 8px;border-bottom:1px solid #e5e7eb;vertical-align:top}
  .items .num{text-align:right;white-space:nowrap}
  .group-h{background:#eef2fb;border-left:3px solid #C9A227;padding:5px 10px;margin-top:12px;font-weight:700;color:#0A1633}
  .subtotal{background:#f7f3e8;font-weight:700}
  .tot{width:100%;font-size:13px;margin-top:10px}.tot td{padding:4px 0}
  .badge{display:inline-block;padding:2px 8px;border-radius:999px;font-size:10px;font-weight:700;border:1px solid #C9A227;color:#0A1633}
  @media print{body{margin:0}thead{display:table-header-group}}`;

const _sigInner = `<div style="text-align:center;min-width:190px">
    <div class="muted">Hormat kami,</div>
    <img src="/ttd-owner.jpeg" alt="Tanda tangan Owner" style="height:64px;margin:4px auto 2px;display:block" />
    <div style="font-weight:700;border-bottom:1.5px solid #111;display:inline-block;min-width:190px;padding-bottom:2px">Agus Guntoro</div>
    <div class="muted" style="margin-top:3px">Owner — Lala Corporation Indonesia</div>
  </div>`;

const _signature = `<div style="display:flex;justify-content:flex-end;margin-top:36px">
  ${_sigInner}
</div>`;

const _payInfo = `<div style="font-size:11px;color:#333;white-space:pre-line;line-height:1.55">Untuk Pembayarannya Bisa Ditransfer Ke :
A.N Agus Guntoro
BCA : 1481482751
BNI : 0983928177
BRI : 377201020861535
Mandiri: 1770017789493
Permata : 4204403002
SinarMas : 0052971087
CIMB Niaga: 762251913500
Gopay / OVO: 085295362929
PayPal: @lalafloristindonesia
SeaBank: 901255277657

Mohon Kirimkan Bukti Transfernya Ya
Terimakasih</div>`;

const _signatureWithPay = `<div style="display:flex;justify-content:space-between;align-items:flex-end;gap:24px;margin-top:36px">
  ${_payInfo}
  ${_sigInner}
</div>`;

const _combHeader = (title, invoiceNo, right) => `
  <div style="display:flex;justify-content:space-between;align-items:flex-start">
    <div style="display:flex;align-items:center;gap:12px">
      <img src="https://customer-assets-jai6qajn.emergentagent.net/job_business-ledger-540/artifacts/e4f82042f591207e_WhatsApp%20Image%202026-10-07%20at%2015.59.58.jpeg" style="height:58px;width:58px;object-fit:cover;border-radius:12px;border:1px solid #C9A227" />
      <div><h1>LALA CORPORATION INDONESIA</h1><div class="muted">${title}</div></div>
    </div>
    <div style="text-align:right"><div class="muted">No. Invoice</div><div style="font-weight:700">${_esc(invoiceNo)}</div><div class="muted" style="margin-top:2px">Dicetak: ${formatDate(new Date().toISOString())}</div>${right || ""}</div>
  </div>`;

const _groupStatus = (bills) => {
  const rem = bills.reduce((s, b) => s + (b.remaining || 0), 0);
  const paid = bills.reduce((s, b) => s + (b.paid || 0), 0);
  if (rem <= 0.5) return "Lunas";
  if (paid > 0) return "Dibayar Sebagian";
  return "Belum Dibayar";
};

const _openPrint = (title, body, wa) => {
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${_esc(title)}</title><style>${_combCss}</style></head><body><div id="inv">${body}</div>${_waBar(wa && wa.phone, (wa && wa.invNo) || title)}<script>window.onload=function(){window.print()}</script></body></html>`;
  const w = window.open("", "_blank", "width=780,height=920");
  if (w) { w.document.write(html); w.document.close(); }
  else { toast.error("Popup cetak diblokir browser. Izinkan popup untuk mencetak invoice."); }
};

const _custRows = (bills) => bills.map((b) => {
  const flat = (s) => (s || "").split("\n").map((x) => x.trim()).filter(Boolean).join(", ");
  const note = [b.ucapan ? "Ucapan: " + flat(b.ucapan) : "", b.dari ? "Dari: " + flat(b.dari) : "", b.alamat ? "Alamat: " + flat(b.alamat) : ""].filter(Boolean).join(" · ");
  return `<tr>
    <td>${_esc(b.order_no) || "-"}</td><td style="white-space:nowrap">${formatDate(b.date)}</td>
    <td>${_esc(b.category) || "-"}${note ? `<div class="muted" style="margin-top:2px;font-size:10px;line-height:1.35">${_esc(note)}</div>` : ""}</td>
    <td class="num">${b.quantity || 1}</td>
    <td class="num">${formatIDR(b.unit_sell != null ? b.unit_sell : b.amount)}</td>
    <td class="num">${formatIDR(b.amount)}</td>
    <td class="num">${formatIDR(b.paid || 0)}</td>
    <td class="num">${formatIDR(b.remaining || 0)}</td>
    <td>${_esc(b.payment_status)}${b.overdue ? " (Jatuh Tempo)" : ""}</td>
  </tr>`;
}).join("");

const _custCols = `<tr><th>No. Order</th><th>Tgl Order</th><th style="width:32%">Pesanan</th><th class="num">Qty</th><th class="num">Harga</th><th class="num">Total</th><th class="num">Dibayar</th><th class="num">Sisa</th><th>Status</th></tr>`;

const _custTotals = (bills) => ({
  count: bills.length,
  tagihan: bills.reduce((s, b) => s + (b.amount || 0), 0),
  dibayar: bills.reduce((s, b) => s + (b.paid || 0), 0),
  sisa: bills.reduce((s, b) => s + (b.remaining || 0), 0),
});

export function printCustomerCombinedInvoice({ admin, customer, phone, periodLabel, bills }) {
  const t = _custTotals(bills);
  const invNo = `INV-PLG-${_stamp()}`;
  const body = `
    ${_combHeader("Invoice Gabungan Tagihan Pelanggan", invNo, `<span class="badge">${_groupStatus(bills)}</span>`)}
    <div class="hr"></div>
    <table class="meta">
      <tr><td style="color:#555;width:130px">Pelanggan</td><td style="font-weight:600">${_esc(customer)}${phone ? " · " + _esc(phone) : ""}</td>
          <td style="color:#555;width:110px">Admin</td><td style="font-weight:600">${_esc(admin)}</td></tr>
      <tr><td style="color:#555">Periode Order</td><td>${_esc(periodLabel)}</td>
          <td style="color:#555">Jumlah Order</td><td>${t.count} order</td></tr>
    </table>
    <div class="hr"></div>
    <table class="items"><thead>${_custCols}</thead><tbody>${_custRows(bills)}</tbody></table>
    <table class="tot">
      <tr><td style="color:#555">Total Tagihan (${t.count} order)</td><td class="num" style="font-weight:600">${formatIDR(t.tagihan)}</td></tr>
      <tr><td style="color:#555">Total Pembayaran Diterima</td><td class="num">${formatIDR(t.dibayar)}</td></tr>
      <tr class="subtotal"><td style="padding:8px">Sisa Tagihan</td><td class="num" style="padding:8px">${formatIDR(t.sisa)}</td></tr>
      <tr><td style="color:#555">Status Pembayaran</td><td class="num"><b>${_groupStatus(bills)}</b></td></tr>
    </table>
    ${_signatureWithPay}
    <p class="muted" style="margin-top:20px">Invoice gabungan ini merangkum seluruh order yang tercantum dan dapat ditelusuri melalui nomor order masing-masing.</p>`;
  _openPrint(`Invoice ${customer}`, body, { phone, invNo });
}

export function printCustomerAdminRecap({ admin, periodLabel, groups }) {
  const sections = groups.map((g) => {
    const t = _custTotals(g.bills);
    return `<div class="group-h">${_esc(g.customer)} — ${g.bills.length} order · ${formatIDR(t.tagihan)}</div>
      <table class="items"><thead>${_custCols}</thead><tbody>${_custRows(g.bills)}</tbody>
      <tfoot><tr class="subtotal"><td colspan="5">Subtotal ${_esc(g.customer)}</td><td class="num">${formatIDR(t.tagihan)}</td><td class="num">${formatIDR(t.dibayar)}</td><td class="num">${formatIDR(t.sisa)}</td><td>${_groupStatus(g.bills)}</td></tr></tfoot></table>`;
  }).join("");
  const all = groups.flatMap((g) => g.bills);
  const gt = _custTotals(all);
  const body = `
    ${_combHeader("Rekap Invoice Keseluruhan Admin — Tagihan Pelanggan", `INV-ADM-${_stamp()}`)}
    <div class="hr"></div>
    <table class="meta">
      <tr><td style="color:#555;width:130px">Admin</td><td style="font-weight:600">${_esc(admin)}</td>
          <td style="color:#555;width:110px">Periode</td><td>${_esc(periodLabel)}</td></tr>
      <tr><td style="color:#555">Pelanggan</td><td>${groups.length} pelanggan</td>
          <td style="color:#555">Total Order</td><td>${gt.count} order</td></tr>
    </table>
    ${sections}
    <div class="hr"></div>
    <table class="tot">
      <tr><td style="color:#555">Total Seluruh Tagihan (${gt.count} order)</td><td class="num" style="font-weight:600">${formatIDR(gt.tagihan)}</td></tr>
      <tr><td style="color:#555">Total Pembayaran Diterima</td><td class="num">${formatIDR(gt.dibayar)}</td></tr>
      <tr class="subtotal"><td style="padding:8px">Total Sisa Tagihan</td><td class="num" style="padding:8px">${formatIDR(gt.sisa)}</td></tr>
    </table>
    ${_signatureWithPay}`;
  _openPrint(`Rekap Admin ${admin}`, body, { phone: "", invNo: `INV-ADM-PLG-${_stamp()}` });
}

const _supRows = (bills) => bills.map((b) => {
  const flat = (s) => (s || "").split("\n").map((x) => x.trim()).filter(Boolean).join(", ");
  const note = [b.ucapan ? "Ucapan: " + flat(b.ucapan) : "", b.dari ? "Dari: " + flat(b.dari) : "", b.alamat ? "Alamat: " + flat(b.alamat) : ""].filter(Boolean).join(" · ");
  return `<tr>
    <td>${_esc(b.invoice_no) || "-"}</td><td style="white-space:nowrap">${formatDate(b.issue_date)}</td>
    <td>${_esc(b.description) || "-"}${note ? `<div class="muted" style="margin-top:2px;font-size:10px;line-height:1.35">${_esc(note)}</div>` : ""}</td>
    <td class="num">${formatIDR(b.amount)}</td>
    <td class="num">${formatIDR(b.paid || 0)}</td>
    <td class="num">${formatIDR(b.remaining || 0)}</td>
    <td>${_esc(b.payment_status)}${b.overdue ? " (Jatuh Tempo)" : ""}</td>
  </tr>`;
}).join("");

const _supCols = `<tr><th>No. Invoice/Order</th><th>Tgl Terbit</th><th style="width:36%">Referensi Order</th><th class="num">Tagihan</th><th class="num">Dibayar</th><th class="num">Sisa</th><th>Status</th></tr>`;

const _supTotals = (bills) => ({
  count: bills.length,
  tagihan: bills.reduce((s, b) => s + (b.amount || 0), 0),
  dibayar: bills.reduce((s, b) => s + (b.paid || 0), 0),
  sisa: bills.reduce((s, b) => s + (b.remaining || 0), 0),
});

export function printSupplierCombinedInvoice({ admin, supplier, phone, periodLabel, bills }) {
  const t = _supTotals(bills);
  const invNo = `INV-SUP-${_stamp()}`;
  const body = `
    ${_combHeader("Invoice Gabungan Tagihan Supplier", invNo, `<span class="badge">${_groupStatus(bills)}</span>`)}
    <div class="hr"></div>
    <table class="meta">
      <tr><td style="color:#555;width:130px">Supplier</td><td style="font-weight:600">${_esc(supplier)}${phone ? " · " + _esc(phone) : ""}</td>
          <td style="color:#555;width:110px">Admin</td><td style="font-weight:600">${_esc(admin)}</td></tr>
      <tr><td style="color:#555">Periode Order</td><td>${_esc(periodLabel)}</td>
          <td style="color:#555">Jumlah Order</td><td>${t.count} order</td></tr>
    </table>
    <div class="hr"></div>
    <table class="items"><thead>${_supCols}</thead><tbody>${_supRows(bills)}</tbody></table>
    <table class="tot">
      <tr><td style="color:#555">Total Tagihan Supplier (${t.count} order)</td><td class="num" style="font-weight:600">${formatIDR(t.tagihan)}</td></tr>
      <tr><td style="color:#555">Total Pembayaran Dilakukan</td><td class="num">${formatIDR(t.dibayar)}</td></tr>
      <tr class="subtotal"><td style="padding:8px">Sisa Hutang ke Supplier</td><td class="num" style="padding:8px">${formatIDR(t.sisa)}</td></tr>
      <tr><td style="color:#555">Status Pembayaran</td><td class="num"><b>${_groupStatus(bills)}</b></td></tr>
    </table>
    ${_signature}
    <p class="muted" style="margin-top:20px">Nominal sesuai kewajiban kepada supplier. Setiap baris dapat ditelusuri melalui nomor invoice/order masing-masing.</p>`;
  _openPrint(`Invoice Supplier ${supplier}`, body, { phone, invNo });
}

export function printSupplierAdminRecap({ admin, periodLabel, groups }) {
  const sections = groups.map((g) => {
    const t = _supTotals(g.bills);
    return `<div class="group-h">${_esc(g.supplier)} — ${g.bills.length} order · ${formatIDR(t.tagihan)}</div>
      <table class="items"><thead>${_supCols}</thead><tbody>${_supRows(g.bills)}</tbody>
      <tfoot><tr class="subtotal"><td colspan="3">Subtotal ${_esc(g.supplier)}</td><td class="num">${formatIDR(t.tagihan)}</td><td class="num">${formatIDR(t.dibayar)}</td><td class="num">${formatIDR(t.sisa)}</td><td>${_groupStatus(g.bills)}</td></tr></tfoot></table>`;
  }).join("");
  const all = groups.flatMap((g) => g.bills);
  const gt = _supTotals(all);
  const body = `
    ${_combHeader("Rekap Invoice Keseluruhan Admin — Tagihan Supplier", `INV-ADM-${_stamp()}`)}
    <div class="hr"></div>
    <table class="meta">
      <tr><td style="color:#555;width:130px">Admin</td><td style="font-weight:600">${_esc(admin)}</td>
          <td style="color:#555;width:110px">Periode</td><td>${_esc(periodLabel)}</td></tr>
      <tr><td style="color:#555">Supplier</td><td>${groups.length} supplier</td>
          <td style="color:#555">Total Order</td><td>${gt.count} order</td></tr>
    </table>
    ${sections}
    <div class="hr"></div>
    <table class="tot">
      <tr><td style="color:#555">Total Seluruh Tagihan Supplier (${gt.count} order)</td><td class="num" style="font-weight:600">${formatIDR(gt.tagihan)}</td></tr>
      <tr><td style="color:#555">Total Pembayaran Dilakukan</td><td class="num">${formatIDR(gt.dibayar)}</td></tr>
      <tr class="subtotal"><td style="padding:8px">Total Sisa Hutang</td><td class="num" style="padding:8px">${formatIDR(gt.sisa)}</td></tr>
    </table>
    ${_signature}`;
  _openPrint(`Rekap Admin Supplier ${admin}`, body, { phone: "", invNo: `INV-ADM-SUP-${_stamp()}` });
}


export function printSupplierDebtRecap({ periodLabel, rows, total, title = "Rekap Hutang Supplier per Admin", partyLabel = "Supplier", debtLabel = "Sisa Hutang" }) {
  const tr = rows.map((r, i) => `<tr><td>${i + 1}</td><td>${_esc(r.admin)}</td><td class="num">${r.count}</td><td class="num">${r.suppliers}</td>
    <td class="num">${formatIDR(r.tagihan)}</td><td class="num">${formatIDR(r.dibayar)}</td><td class="num"><b>${formatIDR(r.hutang)}</b></td><td class="num">${formatIDR(r.overdue)}</td></tr>`).join("");
  const body = `
    ${_combHeader(title, `REKAP-HUT-${_stamp()}`)}
    <div class="hr"></div>
    <table class="meta">
      <tr><td style="color:#555;width:130px">Periode</td><td style="font-weight:600">${_esc(periodLabel)}</td>
          <td style="color:#555;width:110px">Jumlah Admin</td><td>${rows.length} admin</td></tr>
    </table>
    <table class="items"><thead><tr><th>No</th><th>Admin</th><th class="num">Order</th><th class="num">${partyLabel}</th><th class="num">Total Tagihan</th><th class="num">Dibayar</th><th class="num">${debtLabel}</th><th class="num">Jatuh Tempo</th></tr></thead>
      <tbody>${tr}</tbody>
      <tfoot><tr class="subtotal"><td colspan="2">Total</td><td class="num">${total.count}</td><td class="num">-</td><td class="num">${formatIDR(total.tagihan)}</td><td class="num">${formatIDR(total.dibayar)}</td><td class="num">${formatIDR(total.hutang)}</td><td class="num">${formatIDR(total.overdue)}</td></tr></tfoot></table>
    <table class="tot">
      <tr><td style="color:#555">Total Tagihan</td><td class="num" style="font-weight:600">${formatIDR(total.tagihan)}</td></tr>
      <tr><td style="color:#555">Total Dibayar</td><td class="num">${formatIDR(total.dibayar)}</td></tr>
      <tr class="subtotal"><td style="padding:8px">Total ${debtLabel}</td><td class="num" style="padding:8px">${formatIDR(total.hutang)}</td></tr>
    </table>
    ${_signature}
    <p class="muted" style="margin-top:20px">${debtLabel} hanya menghitung tagihan Belum Dibayar & Dibayar Sebagian. "Tanpa Admin" = data lama tanpa admin pembuat.</p>`;
  _openPrint(title, body, { phone: "", invNo: `REKAP-HUT-${_stamp()}` });
}
